
<div :class="jel_getClassObject(content)">
  <div class="container p-0 pt-1">
    <div
      v-if="isSpinnerVisible"
      id="spinner"
      class="d-flex flex-column justify-content-center align-items-center text-center"
    >
      <b-spinner :label="$t('chargement')"></b-spinner>
    </div>
    <div class="row">
      <div class="col text-left">
        <!-- Affichage des erreurs systèmes -->
        <div v-if="isErreurServeur">
          <MessageMel
            v-show="contentMessageMel.message"
            :content="contentMessageMel.message"
            class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
          ></MessageMel>
        </div>
        <!-- Aucune erreur système (cas normal)  -->
        <div v-else>            
          <div v-if="gameActivity[selectedPeriod]">
            <Paragraphe
              :content="{
                richText: content.titrePeriode,
                classeCSS: 'font-weight-bold text-left pt-1 pb-2',
              }"
            ></Paragraphe>
            <div class="period-buttons">
              <button
                v-for="key in Object.keys(gameActivity)"
                :key="key"
                class="btn button-period"
                :class="{ active: selectedPeriod === key }"
                @click="selectedPeriod = key"
              >
                {{ $t('messageComponent.jour', { nb: key }) }}
              </button>
            </div>
            <p class="period-range">
              {{ $t('messageComponent.du') }} {{ gameActivity[selectedPeriod].startDate }} {{ $t('messageComponent.au') }}
              {{ gameActivity[selectedPeriod].endDate }}
            </p>
            <div class="game-activity-container">
              <div class="info-box">
                <div class="gains-pertes">
                  <div class="d-flex flex-wrap label">
                    <div class="col-6 text-left">{{ content.titreGain }}</div>
                    <div class="col-6 text-right pb-1">
                      {{ gameActivity[selectedPeriod].winloss }}
                    </div>
                  </div>
                  <div class="gain-info italic col-12 text-left pb-2">{{ content.infoGain }}</div>
                </div>
                <div class="stats">
                  <div class="stat-item">
                    <div class="pt-1">{{ content.titreDepot }}</div>
                    <div class="pb-1 label">{{ gameActivity[selectedPeriod].deposit }}</div>
                  </div>
                  <div class="stat-item">
                    <div class="pt-1">{{ content.titreRetait }}</div>
                    <div class="pb-1 label">{{ gameActivity[selectedPeriod].withdrawn }}</div>
                  </div>
                </div>
                <div class="stats">
                  <div class="stat-item">
                    <div class="pt-1">{{ content.titreNbJours }}</div>
                    <div class="pb-1 label">{{ gameActivity[selectedPeriod].playdays }}</div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-item-icon">
                      <div class="pt-1">{{ content.titreTempsJeux }}</div>
                      <Hyperlien
                        v-if="contentLienAideTempsJeux"
                        class="lien-aide ml-0 mt-1 mr-0 ml-1 rounded-circle cercleInfo"
                        :content="contentLienAideTempsJeux"
                      ></Hyperlien>
                    </div>
                    <div class="pb-1 label">
                      {{ gameActivity[selectedPeriod].playduration }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Paragraphe
            :content="{
              richText: content.txtLegal,
              classeCSS: 'pt-2',
            }"
            class="texte-legal"
          ></Paragraphe>
        </div>
      </div>
    </div>
  </div>
</div>
